<template>
  <section class="what-we-do section" id="what-we-do">
    <div class="wrapper">
      <div class="content">
        <h1 class="title">O que fazemos</h1>
        <div class="content-box">
          <div class="select-container" :class="{active : dropdown}">
            <div class="selector">
              <span class="selector-first" @click.prevent="dropdown = !dropdown"
              v-for="(area, index) in api.areas_de_atuacao"
              :key="index"
              v-show="currentArea == index">{{area.titulo}}</span>
              <ul class="dropdown" :class="{active : dropdown}">
                <li
                v-for="(area, index) in api.areas_de_atuacao"
                :key="index"
                @click="currentArea = index, dropdown = !dropdown">{{area.titulo}}</li>
              </ul>
            </div>
          </div>
          <transition-group name="areas" tag="div" class="text-container">
            <p class="text"
            :key="index"
            v-for="(area, index) in api.areas_de_atuacao"
            v-html="area.texto"
            v-show="currentArea == index">
            </p>
          </transition-group>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'OQueFazemos',
  props: ['api'],
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      dropdown: false,
      currentArea: 0
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus">
  #what-we-do
    background url('../assets/what-we-do-bg.jpg') center no-repeat
    background-size cover
    .areas-enter-active, .areas-leave-active
      transition all 1s
    .areas-enter
      transform translateX(-30px)
      opacity 0
    .areas-leave
      transform translateX(-30px)
      opacity 0
    .content
      position relative
      top 100px
    .title
      margin-bottom 85px
    .content-box
      box-shadow 0 0 15px rgba(0,0,0, .1)
      padding 80px 100px
      background white
      position relative
      @media (max-width 640px)
        padding 80px 40px
      .selector
        font-size 26px
        font-weight bold
        box-shadow 0 0 15px rgba(0,0,0, .1)
        border 0
        width 100%
        margin 0
        appearance none
        outline none
        background white
        .selector-first
          padding 20px 20px
          display block
          cursor pointer
      .dropdown
        opacity 0
        max-height 0
        padding-top 0
        visibility hidden
        margin 0
        position relative
        transition .3s all ease
        &.active
          opacity 1
          visibility visible
          max-height 315px
          overflow-y scroll
          &:after
            content ''
            width 100%
            position fixed
            bottom 0
            height 20px
            background linear-gradient(rgba(255,255,255, .2), rgba(255,255,255, 1))
        li
          border-top 1px solid #ccc
          padding 20px
          font-weight 300
          cursor pointer
          font-size 21px
          color #aaa
          
      .select-container
        position absolute
        width 100%
        max-width 600px
        top -30px
        left 50%
        transform translateX(-50%)
        &:after
          content ''
          display block
          position absolute
          right 30px
          top 29px
          pointer-events none
          width 27px
          height 18px
          background url('../assets/arrow-down@2x.png') no-repeat center
          animation downArrow 0.5s linear infinite alternate
          transition .5s all ease
        &.active
          &:after
            transform rotate(180deg)

@-webkit-keyframes downArrow
    from
      top 28px
    to
      top 33px
</style>



// WEBPACK FOOTER //
// src/components/WhatWeDoSection.vue